export {};
//# sourceMappingURL=ZWaveSocketOptions.js.map